import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { hot } from 'react-hot-loader';
import { Route, Redirect, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { flattenMessages } from 'HELPERS/utils';
import configureStore, { history } from 'STORE/configureStore';
import { AuthSignInPage, ReportsPage } from 'PAGES';
import { NotFoundPage, GenericErrorPage } from 'PAGES/ErrorPages';
import { ControlPage } from 'PAGES/Control';
import Echo from 'laravel-echo';
import rootSaga from 'STORE/sagas';

import './App.less';

window.io = require('socket.io-client');

const locale = 'en-ca';
// Import the current locale file with translations
// eslint-disable-next-line import/no-dynamic-require
const localeData = require(`./intl/resources/${locale}.json`);
const messages = flattenMessages(localeData);
const intlProvider = new IntlProvider({ locale, messages }, {});
// Export the intl provider as a separated lib to be used in non-components files
export const { intl } = intlProvider.getChildContext();

// Expose the intl provider to be used on helpers or non react components
if (typeof window !== 'undefined') {
  window.intl = intl;
}

window.Echo = new Echo({
  namespace: 'App.Events',
  broadcaster: 'socket.io',
  host: process.env.REACT_APP_SOCKET_HOST,
});

export const store = configureStore(intl);

store.runSaga(rootSaga);

const App = () => (
  <Provider store={store}>
    <IntlProvider locale={navigator.language} messages={messages}>
      <ConnectedRouter history={history}>
        <React.Fragment>
          <Switch>
            <Route path="/" exact render={() => (<Redirect to="/control/generate-preview" />)} />
            <Route path="/control" exact render={() => (<Redirect to="/control/generate-preview" />)} />
            <Route path="/sign-in" component={AuthSignInPage} />
            <Route path="/control" component={ControlPage} />
            <Route path="/reports" component={ReportsPage} />
            <Route path="/sorry" exact component={GenericErrorPage} />
            <Route path="*" component={NotFoundPage} />
          </Switch>
        </React.Fragment>
      </ConnectedRouter>
    </IntlProvider>
  </Provider>
);

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App.js